import {jobClosed} from "./jobClosed";

export default async function filterResponse(response) {
	if (response.status === 401) {
		const {link} = await response.json();

		return window.location.href = link + '?redirectURL=' + encodeURIComponent(window.location.href);
	}

	// The job closed under us (archived, or our submission delivered from Inspect). Every request
	// from here on is refused, so take the page down rather than let the contributor keep working on
	// something that can no longer be saved.
	//
	// Read a clone: the caller still has its own response body to read.
	if (response.status === 409) {
		try {
			const body = await response.clone().json();

			if (body?.jobClosed) {
				jobClosed(body.error);
				// Returned as well as broadcast, for callers in the middle of a multi-step
				// operation (an upload) that have to stop rather than read this as a failure of
				// the one step.
				return {jobClosed: true, error: body.error};
			}
		}
		catch (e) {
			// Not every 409 carries JSON (a duplicate upload answers with an empty body), and one
			// that doesn't simply isn't this case.
			console.warn("Could not read the body of a 409 response", e);
		}
	}
}
